import { FC } from 'react';

import Card from 'src/components/atoms/Card';
import RequestFormCTA, { RequestFormCTAProps } from 'components/molecules/RequestFormCTA';

const BlogValuePropositionCard: FC<RequestFormCTAProps> = ({
  children,
  onClick,
  gtmClasses,
  dataGtmClick,
}) => (
  <Card elevation="medium">
    {children}
    <RequestFormCTA
      onClick={onClick}
      gtmClasses={gtmClasses}
      dataGtmClick={dataGtmClick}
      hasDropShadow={true}
    />
  </Card>
);

export default BlogValuePropositionCard;
